
export default "/assets/arrow-right-micro.b3f4db07.svg"